/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Team_Manager_Remove_Group_FailedInputs */

const en_team_manager_remove_group_failed = /** @type {(inputs: Team_Manager_Remove_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to remove group. ${i?.error}`)
};

const fr_team_manager_remove_group_failed = /** @type {(inputs: Team_Manager_Remove_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de la suppression du groupe. ${i?.error}`)
};

const de_team_manager_remove_group_failed = /** @type {(inputs: Team_Manager_Remove_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gruppe konnte nicht entfernt werden. ${i?.error}`)
};

const it_team_manager_remove_group_failed = /** @type {(inputs: Team_Manager_Remove_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile rimuovere il gruppo. ${i?.error}`)
};

const ru_team_manager_remove_group_failed = /** @type {(inputs: Team_Manager_Remove_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось удалить группу. ${i?.error}`)
};

const es_team_manager_remove_group_failed = /** @type {(inputs: Team_Manager_Remove_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo eliminar el grupo. ${i?.error}`)
};

const zh_cn2_team_manager_remove_group_failed = /** @type {(inputs: Team_Manager_Remove_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`移除组失败。${i?.error}`)
};

const ja_team_manager_remove_group_failed = /** @type {(inputs: Team_Manager_Remove_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`グループの削除に失敗しました。${i?.error}`)
};

const hi_team_manager_remove_group_failed = /** @type {(inputs: Team_Manager_Remove_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`समूह को हटाने में विफल। ${i?.error}`)
};

const pt_pt2_team_manager_remove_group_failed = /** @type {(inputs: Team_Manager_Remove_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao remover o grupo. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to remove group. {error}" |
*
* @param {Team_Manager_Remove_Group_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_remove_group_failed = /** @type {((inputs: Team_Manager_Remove_Group_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Remove_Group_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_remove_group_failed(inputs)
	if (locale === "de") return de_team_manager_remove_group_failed(inputs)
	if (locale === "it") return it_team_manager_remove_group_failed(inputs)
	if (locale === "ru") return ru_team_manager_remove_group_failed(inputs)
	if (locale === "es") return es_team_manager_remove_group_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_remove_group_failed(inputs)
	if (locale === "ja") return ja_team_manager_remove_group_failed(inputs)
	if (locale === "hi") return hi_team_manager_remove_group_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_remove_group_failed(inputs)
	return en_team_manager_remove_group_failed(inputs)
});